export default {
    error: 'Authentication error',
    forbidden: 'Access denied',
    errors: {
        authInitializationFailed: 'Your session could not be restored. Please refresh the page.',
        unknown: 'An unknown error has occurred. Please try again.',
        userNotActive: "This user's access has been disabled.",
        userRestricted: "This user's access is restricted.",
        crmLiteFullCrmForbidden:
            'This dealership uses CRM Lite. Open Dealer Dashboard and choose Lead Management to continue.',
    },
    newPassword: {
        alerts: {
            success: 'Your password has been changed successfully.',
        },
        changePassword: 'Change password',
        errors: {
            passwordDoNotMatch: 'The password and the password confirmation do not match.',
            unknownError: 'An unknown error occurred.',
            invalidToken: 'The reset password token is expired.',
        },
        instructions: "You're almost done!<br>Please enter a new password (at least 8 characters).",
    },
    password: 'Password',
    passwordConfirmation: 'Retype password',
    refreshPage: 'Refresh page',
    retry: 'Retry',
};
